import { useCallback } from 'react';

import { TServerSendRequest } from '../../types';
import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useGetForcedLossLimits = () => {
    const send = useGenericSend();

    return useCallback(async (): Promise<Types.IGetForcedLossLimitsResponseData> => {
        const { data } = await send<TServerSendRequest, Types.IGetForcedLossLimitsResponseData>({
            ID: 35856,
            responses: [35857, 35858],
            description: 'Get forced loss limits',
            errorLevel: 1
        });

        return data;
    }, [
        send
    ]);
};
